/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import { DocumentStatusModel } from '@well/delivery-libs/fleet-management-shared/domain';

export class VehicleDocumentUpdateStatusDtoModel extends JSONable{
    vehicleDocumentUuid: string | undefined
    active: DocumentStatusModel | undefined
}
